import { SECTION_LABEL_NODE_PADDING } from '@/components/diagrams/FlowChart/constants';
import { createSectionBoundsHandlers } from '@/components/diagrams/FlowChart/nodes/SectionLabelNode/hooks';

import { EntityDiagramState } from '../types';
import { getDispositionsInterSectionPadding } from '../utils/getDispositionsInterSectionPadding';

export function applySectionBoundsToState(
  state: EntityDiagramState
): EntityDiagramState {
  // Section-bound handlers mutate positions in place. Clone nested mutable
  // fields so auto-layout does not alter the pre-layout history snapshot.
  const nodes = state.nodes.map((node) => ({
    ...node,
    position: { ...node.position },
    ...(node.style ? { style: { ...node.style } } : {}),
  }));
  if (!nodes.length) {
    return { ...state, nodes };
  }

  const { interSectionPadding, labelPadding } =
    getDispositionsInterSectionPadding({
      nodes,
      edges: state.edges,
      isInHalfWidthContainer: state.isInHalfWidthContainer,
      entityDiagramVariant: state.entityDiagramVariant,
      targetAspectRatio: state.containerAspectRatio,
    });

  const { initSectionBounds } = createSectionBoundsHandlers({
    changes: [],
    nextNodes: nodes,
    padding: SECTION_LABEL_NODE_PADDING,
    labelPadding,
    interSectionPadding,
  });

  initSectionBounds();

  return { ...state, nodes };
}
